import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid } from '@material-ui/core'
import Utils from '../../providers/Utils';





export default class PonteazaAcum extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }

    openMaps= () =>{

        // console.log('this.props.latitude :', this.props.latitude);
        // console.log('this.props.longitude :', this.props.longitude);
        window.open(`https://maps.google.com/?ll=${this.props.latitude},${this.props.longitude}`)
    }

    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='sm'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 style={{ marginBottom: 0 }} className='pm-title'>{this.props.title}</h2>
                    <h3 style={{ marginBottom: 0 }} className='pm-title'>{this.props.dataSelectata}</h3>
                    <h4 style={{ marginTop: 0, color: '#5a0be8' }} className='pm-title'>Timp Lucru: {this.props.timer}</h4>
                    <div style={{ textAlign: 'center' }}>
                        <span style={{ color: 'red' }} className='pm-title'>Absent</span>
                        <Switch
                            className={this.props.prezent !== 1 ? '' : "pm-switch"}
                            checked={this.props.prezent !== 1 ? false : true}
                            onChange={this.props.handlePrezent}
                            value='companie'
                        />
                        <span className='pm-title' style={{ color: '#10aa2ac5' }}>Prezent</span>
                    </div>


                    {this.props.prezent === 1 &&
                        <Grid container className="container pm-dialog-textfield-container" >
                         <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <h3 style={{marginTop:0, cursor:'pointer'}} onClick={this.openMaps} className='pm-title'> <i style={{verticalAlign:'bottom'}} className='material-icons'>explore</i>Locatie</h3>

                         </Grid>


                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    id="with-placeholder"
                                    label={'Start Pontaj'}
                                    name={'cand_inceput_ora'}
                                    disabled={this.props.status !== 'Started' ? false : true}
                                    margin="normal"
                                    type='time'
                                    value={this.props.nrOraInceput || ''}
                                    onChange={this.props.handleChange}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>


                            <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    id="with-placeholder"
                                    name={'cand_sfarsit_ora'}
                                    label={'Sfarsit Pontaj'}
                                    margin="normal"
                                    type='time'
                                    value={this.props.nrOraSfarsit || ''}
                                    onChange={this.props.handleChange}
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                />
                            </Grid>


                        </Grid>

                    }

                    {this.props.prezent !== 1 &&
                    <Grid container className="container pm-dialog-textfield-container" >


                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                        <TextField
                            className="inputFocus loginTextField"
                            id="with-placeholder"
                            label={'Motiv Absenta'}
                            name={'absent_motivatie'}
                            margin="normal"
                            type='text'
                            value={this.props.absentMotivatie || ''}
                            onChange={this.props.handleChange}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>


                  


                </Grid>
                    }



                    <DialogActions className="pm-dialog-bottom-buttons">

                        <Button variant="outlined" onClick={this.props.updatePontaj} className='pm-save-button'>
                            Editeaza
                          </Button>




                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}